import CheckPointModal from './CheckPointModal';

export default CheckPointModal;
